<template>
  <div class="categories-wrapper">
    <div class="row row-head">
      <div class="row-item">
        #
      </div>
      <div class="row-item row-item-sortable">
        <Sorting
          :sortField="`c.${sortedField.name}`"
          :currentSortedField="sortFiled"
          :handleSortUp="handleSortUp"
          :handleSortDown="handleSortDown"
        />
        name
      </div>
      <div class="row-item">
        short name
      </div>
      <div class="row-item row-item-sortable">
        <Sorting
          :sortField="`c.${sortedField.updatedAt}`"
          :currentSortedField="sortFiled"
          :handleSortUp="handleSortUp"
          :handleSortDown="handleSortDown"
        />
        Last edited
      </div>
      <div class="row-item">
        Modified By
      </div>
      <div class="row-item">
        Status
      </div>
      <div></div>
    </div>
    <div
      v-if="!categories.length"
      class="empty-search"
    >
      No items to display
    </div>
    <div
      v-for="(item, key) in categories"
      :key="item.id"
      class="row"
    >
      <div class="row-item">
        {{ getCurrentNumber(key) }}
      </div>
      <div
        class="row-item"
        :title="item.name"
      >
        {{ item.name }}
      </div>
      <div
        class="row-item"
        :title="item.industry"
      >
        {{ item.shortName }}
      </div>
      <div class="row-item">
        {{ item.updatedAt | cmsDate(profile.timezone) }}
      </div>
      <div class="row-item">
        {{ (item.updatedBy && item.updatedBy.fullName) || '-' }}
      </div>
      <div class="row-item">
        <div
          class="status-ellipse"
          :class="item.enabled ? 'enabled' : 'disabled'"
        >
        </div>
        <span>
          {{ item.enabled ? 'Enabled' : 'Disabled' }}
        </span>
      </div>
      <div class="row-item row-item-onhover row-item-controls">
        <div
          v-if="isDeleteForItemAvailable(item)"
          :title="'Delete Category'"
        >
          <inline-svg
            :src="iconRemove"
            class="svg-icon remove"
            @click="handleOpenModalForRemove(item)"
          >
          </inline-svg>
        </div>
        <div
          v-if="isAdmin"
          :title="item.enabled ? 'Disable Category' : 'Enable Category'"
          class="enable-icon"
        >
          <inline-svg
            :src="item.enabled ? iconEnabled : iconDisabled"
            class="svg-icon"
            @click="handleOpenToggleStatusModal(item)"
          />
        </div>
        <div
          v-if="isAdmin"
          class="icon-edit"
        >
          <router-link
            :to="{ path: `categories/${item.id}` }"
            :title="'Edit Category'"
          >
            <inline-svg
              :src="iconEdit"
              class="svg-icon"
            >
            </inline-svg>
          </router-link>
        </div>
        <div
          v-if="isManager"
          class="view"
          :title="'View Category'"
        >
          <router-link
            :to="{ path: `categories/${item.id}` }"
          >
            <inline-svg
              :src="iconViewOnly"
              class="svg-icon"
            >
            </inline-svg>
          </router-link>
        </div>
      </div>
    </div>

    <DeleteCategoryInTwoSteps
      ref="deleteCategoryInTwoSteps"
      @runAfterComplete="getCategories"
    />

    <NotificationModal
      ref="modal"
      v-model="bindsForModal.isModalOpen"
      :modal="bindsForModal.isModalOpen"
      v-bind="bindsForModal"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import {
  SET_OVERFLOW,
  SET_EDIT_FORM,
} from '../../store/actions/common';
import {
  SET_CATEGORY_STORE_PROPERTY,
  GET_CATEGORIES_REQUEST,
  GET_CATEGORY_IN_USE_STATUS_REQUEST,
  CHANGE_CATEGORY_STATUS_REQUEST,
} from '../../store/actions/categories/categoriesActions';
import DeleteCategoryInTwoSteps from './DeleteCategoryInTwoSteps.vue';
import NotificationModal from '../../components/NotificationModal.vue';
import Sorting from '../../components/common/Sorting.vue';
import iconEnabled from '../../assets/icons/icon-enabled-acc.svg';
import iconDisabled from '../../assets/icons/icon-disabled-acc.svg';
import iconEdit from '../../assets/icons/icon-edit-acc.svg';
import iconRemove from '../../assets/icons/icon-remove-role.svg';
import iconViewOnly from '../../assets/icons/icon-view-only.svg';
import CONFIG from '../../constants/config';

export default {
  name: 'CategoriesList',
  components: {
    Sorting,
    DeleteCategoryInTwoSteps,
    NotificationModal,
  },
  data() {
    return {
      selectedItem: null,
      bindsForModal: {
        isModalOpen: false,
        title: '',
        bodyMessage: '',
        isInUseAsset: false,
        warningMess: '',
        onAccept: () => {},
        onClose: () => {},
      },
      sortedField: {
        name: 'name',
        updatedAt: 'updatedAt',
      },
      iconEnabled,
      iconDisabled,
      iconRemove,
      iconEdit,
      iconViewOnly,
    };
  },
  computed: {
    ...mapState({
      categories: (state) => state.categories.categories,
      filterValue: (state) => state.categories.filterValue,
      sortFiled: (state) => state.categories.sortFiled,
      sortBy: (state) => state.categories.sortBy,
      pagination: (state) => state.categories.pagination,
      isLoading: (state) => state.accounts.isLoading,
      profile: (state) => state.common.profile,
    }),
    ...mapGetters([
      'getCurrentAccountId',
      'isManager',
      'isAdmin',
    ]),
  },
  mounted() {
    this.$store.commit(SET_CATEGORY_STORE_PROPERTY, {
      key: 'filterValue',
      value: '',
    });

    document.title = 'Categories';

    this.getCategories();
  },
  methods: {
    getCategories() {
      const params = {
        accountId: this.getCurrentAccountId,
        page: localStorage.getItem('categories') || 1,
      };

      this.$store.dispatch(GET_CATEGORIES_REQUEST, params);
    },
    handleSortUp(field) {
      this.$store.commit(SET_CATEGORY_STORE_PROPERTY, {
        key: 'sortFiled',
        value: field,
      });

      this.$store.commit(SET_CATEGORY_STORE_PROPERTY, {
        key: 'sortBy',
        value: CONFIG.sort.sortUp,
      });

      const params = {
        accountId: this.getCurrentAccountId,
        page: this.pagination.page,
      };

      this.$store.dispatch(GET_CATEGORIES_REQUEST, params);
    },
    handleSortDown(field) {
      this.$store.commit(SET_CATEGORY_STORE_PROPERTY, {
        key: 'sortFiled',
        value: field,
      });
      this.$store.commit(SET_CATEGORY_STORE_PROPERTY, {
        key: 'sortBy',
        value: CONFIG.sort.sortDown,
      });

      const params = {
        accountId: this.getCurrentAccountId,
        page: this.pagination.page,
      };

      this.$store.dispatch(GET_CATEGORIES_REQUEST, params);
    },
    handleCloseModal() {
      this.$store.dispatch(SET_OVERFLOW, false);
      this.$store.dispatch(SET_EDIT_FORM, false);
      this.$nextTick(() => {
        this.resetBindsForModal();
      });
    },
    handleOpenToggleStatusModal(item) {
      this.selectedItem = item;

      if (item.enabled) {
        const paramsToGetStatus = {
          accountId: this.getCurrentAccountId,
          id: item.id,
        };

        this.$store.dispatch(GET_CATEGORY_IN_USE_STATUS_REQUEST, paramsToGetStatus)
          .then(this.processOpenToggleStatusModal);
      } else {
        this.processOpenToggleStatusModal({ isInUse: false });
      }
    },
    processOpenToggleStatusModal(response) {
      const { isInUse } = response;
      const {
        disableCategoryTitle,
        disabledCategoryConfirmationMessage,
        enableCategoryTitle,
        enabledCategoryConfirmationMessage,
        categoryInUseWarningMessage,
      } = CONFIG.modals;

      if (this.selectedItem.enabled) {
        this.bindsForModal.title = disableCategoryTitle;
        this.bindsForModal.bodyMessage = disabledCategoryConfirmationMessage;
      } else {
        this.bindsForModal.title = enableCategoryTitle;
        this.bindsForModal.bodyMessage = enabledCategoryConfirmationMessage;
      }

      if (isInUse && this.selectedItem.enabled) {
        this.bindsForModal.isInUseAsset = true;
        this.bindsForModal.warningMess = categoryInUseWarningMessage;
      }

      this.bindsForModal.onAccept = this.handleToggleStatus;
      this.bindsForModal.onClose = this.handleCloseModal;

      this.$store.dispatch(SET_OVERFLOW, true);
      this.bindsForModal.isModalOpen = true;
    },
    handleToggleStatus() {
      const params = {
        accountId: this.getCurrentAccountId,
        categoryId: this.selectedItem.id,
        data: {
          enabled: !this.selectedItem.enabled,
        },
      };

      this.$store.dispatch(CHANGE_CATEGORY_STATUS_REQUEST, params)
        .then(() => {
          this.$toasted.global.success({
            message: `The Category has been successfully
            ${this.selectedItem.enabled ? 'disabled' : 'enabled'}`,
          });
          this.getCategories();
        });
    },
    resetBindsForModal() {
      this.bindsForModal = {
        isModalOpen: false,
        title: '',
        bodyMessage: '',
        isInUseAsset: false,
        warningMess: '',
        onAccept: () => {},
        onClose: () => {},
      };
    },
    getCurrentNumber(key) {
      const { pagination } = this;
      return (pagination.page - 1) * pagination.limit + key + 1;
    },
    isDeleteForItemAvailable(item) {
      return this.isAdmin && !item.enabled && item.canDelete;
    },
    handleOpenModalForRemove(item) {
      this.$refs.deleteCategoryInTwoSteps.handleOpenModalForRemove(item);
    },
  },
};
</script>

<style scoped lang="scss">
.categories-wrapper {
  border: 1px solid #43434d;
  height: 100%;
  overflow-y: auto;
}

.row {
  display: grid;
  grid-template-columns:
    minmax(34px, 44px)
    minmax(200px, 2fr)
    minmax(150px, 1fr)
    minmax(150px, 1fr)
    minmax(90px, 1fr)
    minmax(90px, 1fr)
    140px;
  min-height: 50px;
  height: auto;
  font-size: 14px;
  font-weight: 400;

  &:hover:not(.row-head) {
    background: #383b40;
  }

  .row-item {
    padding: 16px 6px;
    display: flex;
    justify-content: left;
    align-items: flex-start;
    line-height: 18px;
    word-break: break-word;

    &:first-child {
      justify-content: center;
    }

    &.row-item-onhover {
      display: none;
    }

    &.row-item-controls {
      justify-content: flex-end;
      padding: 16px 16px 0px 16px;
      gap: 16px;
    }
  }

  &:hover .row-item-onhover {
    display: flex;
  }
}

.row-head {
  background: #282A2E;
  color: #fff;
  text-transform: uppercase;
  font-size: 12px;

  & .row-item {
    align-items: center;
  }

  & .row-item-sortable {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
}

.status-ellipse {
  border-radius: 50%;
  height: 5px;
  margin-right: 6px;
  margin-top: 6px;
  width: 5px;
}

.status-ellipse.enabled,
.status-ellipse.active {
  background: #1fee65;
}

.status-ellipse.disabled,
.status-ellipse.blocked,
.status-ellipse.pending {
  background: #fb3951;
}

.status-ellipse.failed {
  background: #fbf650;
}

.svg-icon {
  cursor: pointer;
}
</style>
